import { useContext, useEffect } from 'react';
import { useSliderTimer } from "../utils/hooks/useSliderTimer";
import { CarouselCommonContext } from "./context";
export var useCarousel = function useCarousel(_ref) {
  var autoplay = _ref.autoplay;
  var _useContext = useContext(CarouselCommonContext),
    swiperInstance = _useContext.swiperInstance,
    setSwiperInstance = _useContext.setSwiperInstance,
    loop = _useContext.loop;
  var _useSliderTimer = useSliderTimer({
      swiperInstance: swiperInstance,
      slidesCount: (swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slides.length) || 0,
      loop: loop,
      autoplay: autoplay
    }),
    activeIndex = _useSliderTimer.isActiveIndex,
    handleManualSlideChange = _useSliderTimer.handleManualSlideChange,
    setIsActiveIndex = _useSliderTimer.setIsActiveIndex,
    ref = _useSliderTimer.ref;
  var setInstance = function setInstance(swiper) {
    setSwiperInstance === null || setSwiperInstance === void 0 ? void 0 : setSwiperInstance(swiper);
  };
  useEffect(function () {
    swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideTo(activeIndex);
  }, [activeIndex, swiperInstance]);
  useEffect(function () {
    if (!swiperInstance) return;
    setIsActiveIndex(swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.activeIndex);
  }, [swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.activeIndex, setIsActiveIndex, swiperInstance]);
  var handleSlideClick = function handleSlideClick(index) {
    return function () {
      handleManualSlideChange(index);
    };
  };
  return {
    setInstance: setInstance,
    handleSlideClick: handleSlideClick,
    ref: ref,
    activeIndex: activeIndex
  };
};